import React from "react";

// Material UI
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableSortLabel from "@mui/material/TableSortLabel";

const OrdersHeader = ({ order, orderBy, onRequestSort, classes }) => {
  const headCells = [
    { id: "customerName", numeric: false, label: "Customer Name" },
    { id: "brand", numeric: false, label: "Brand" },
    { id: "campaignName", numeric: false, label: "Campaign" },
    {
      id: "orderTotal",
      numeric: true,
      disablePadding: true,
      label: "Total (order price)",
    },
    { id: "orderStatus", numeric: false, label: "Order Status" },
    { id: "orderMessage", numeric: false, label: "Order Message" },
    { id: "scn", numeric: false, label: "SCN" },
    { id: "cardType", numeric: false, label: "Card Type" },
    {
      id: "customerID",
      numeric: true,
      disablePadding: false,
      label: "Customer ID",
    },
    { id: "orderDate", numeric: false, label: "Order Date and Time" },
  ];

  return (
    <TableHead>
      <TableRow
        className="header"
        style={{ border: "solid 2px hotpink !important" }}
      >
        {headCells.map(({id, label}) => (
          <TableCell
            key={id}
            className="headerText"
            align="center"
            padding="normal"
            size="medium"
            sortDirection={orderBy === id ? order : false}
          >
            <TableSortLabel
              direction={orderBy === id ? order : "asc"}
              onClick={(e) => onRequestSort(e, id)}
            >
              {label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default OrdersHeader;
